import {BehaviorSubject} from 'rxjs';
import {callApi, callEmptyParamsApi} from "../connection/ClientApi";
import Urls from "../connection/Urls";

const categoryListSubject = new BehaviorSubject([])
const selectedCategorySubject = new BehaviorSubject({})
const selectedCategoryChildSubject = new BehaviorSubject({})

export const categoryViewModel = {
    requestCategorylist,
    getCategories,
    getCategoryById,
    getCategoryChildById,
    setSelectedCategory,
    getSelectedCategory,
    setSelectedCategoryChild,
    getSelectedCategoryChild,
    requestCategoriesBySupplier,
    categoryList: categoryListSubject.asObservable(),
    selectedCategory: selectedCategorySubject.asObservable(),
    selectedCategoryChild: selectedCategoryChildSubject.asObservable(),
}

function requestCategorylist(onSuccess) {
    callEmptyParamsApi(Urls.getParentCategoryWithChilds, (data) => {
        if (data.list && data.list.length > 0) {
            selectedCategorySubject.next(data.list[0])
            if (data.list[0].childs && data.list[0].childs.length > 0) {
                selectedCategoryChildSubject.next(data.list[0].childs[0])
            }
        }
        categoryListSubject.next(data.list)
        if (onSuccess) {
            onSuccess()
        }
    }, () => {
        categoryListSubject.next([])
    }, () => {

    }, () => {

    })
}

function requestCategoriesBySupplier(params, onSuccess) {
    callApi(Urls.getCategoriesBySupllier, params, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    })
}

function getCategories() {
    let list = categoryListSubject.value
    if (list.length === 0) {
        requestCategorylist(() => {
            return categoryListSubject.value
        })
    } else {
        return list
    }
}

function getSelectedCategory() {
    return selectedCategorySubject.value
}

function getSelectedCategoryChild() {
    return selectedCategoryChildSubject.value
}

function getCategoryById(id) {
    let list = categoryListSubject.value
    if (list) {
        for (let i = 0; i < list.length; i++) {
            for (let j = 0; j < list[i].childs.length; j++) {
                if (list[i].childs[j].id === id) {
                    return list[i]
                }
            }
        }
    }
}

function getCategoryChildById(id) {
    let list = categoryListSubject.value
    if (list) {
        for (let i = 0; i < list.length; i++) {
            for (let j = 0; j < list[i].childs.length; j++) {
                if (list[i].childs[j].id === id) {
                    return list[i].childs[j]
                }
            }
        }
    }
}

function setSelectedCategory(selectedCategory) {
    selectedCategorySubject.next(selectedCategory)
}

function setSelectedCategoryChild(selectedCategoryChild) {
    selectedCategoryChildSubject.next(selectedCategoryChild)
}